/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/alert-banner');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/breadcrumbs');
require('./main/accessibility-dropdown');
require('./main/findstr-sort-labels');
require('./main/findstr-reset-search');

import domReady from '@wordpress/dom-ready';

domReady(() => {
  console.log('Dom is ready');
});
